/**
 * Turns the ids of the columns that stay visible on a collapsed mobile row into the indices DataTable
 * wants. Looking them up by id keeps the collapsed row right when columns are added or reordered.
 * Ids that are not among the visible columns are skipped.
 */
export const resolveMobileHeaderIndices = (visibleColumnIds: string[], headerColumnIds: string[]): number[] =>
  headerColumnIds.map((id) => visibleColumnIds.indexOf(id)).filter((index) => index !== -1);
